module.exports = __webpack_public_path__ + "img/banner5.dd94472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner5.png
// module id = Yix9
// module chunks = 2